import { NgModule } from "@angular/core";
import { MatAutoCompleteComponent } from "./mat-auto-complete/mat-auto-complete.component";
import { MatCommonModule } from "@angular/material/core";
import {
	MatInputModule
} from "@angular/material/input";
import {
	MatAutocompleteModule
} from "@angular/material/autocomplete";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		MatCommonModule,
		MatInputModule,
		MatAutocompleteModule
	],
	declarations: [MatAutoCompleteComponent],
	exports: [MatAutoCompleteComponent]
})
export class TryCatchMaterialExtensionModule {}
